/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Markers_Imported_ToastInputs */



/**
* | output |
* | --- |
* | "OCR results imported as markers." |
*
* @param {Ocr_Markers_Imported_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_markers_imported_toast = /** @type {((inputs?: Ocr_Markers_Imported_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Markers_Imported_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résultats de la reconnaissance optique de caractères (OCR) importés sous forme de marqueurs.")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Ergebnisse wurden als Marker importiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risultati OCR importati come marcatori.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты оптического распознавания символов импортированы в качестве маркеров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultados de OCR importados como marcadores.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR结果导入为标记。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCRの結果がマーカーとしてインポートされます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("OCR परिणामों को मार्कर के रूप में आयात किया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resultados do OCR importados como marcadores.")
	return /** @type {LocalizedString} */ ("OCR results imported as markers.")
});